import constant from "../../core/constant";
import AvailableTable from "../../controllers/available-table";
import AvailableSeat from "../../controllers/setting/seats";

const customer = [
  {
    name: "available-table",
    path: "/available-table",
    component: AvailableTable,
    protected: true,
    exact: true,
    type: constant.ROUTE_TYPE_ADUSER,
  },
  {
    name: "available-seats",
    path: "/available-seats",
    component: AvailableSeat,
    protected: true,
    exact: true,
    type: constant.ROUTE_TYPE_ADUSER,
  },
];

export default customer;
